import React, { Component } from "react";
import {
  Layout,
  Breadcrumb,
  PageHeader,
  Space,
  Row,
  Col,
  DatePicker,
  Select,
  Statistic,
  Card,
  Typography,
  Empty,
  Alert,
} from "antd";
import PieChartPlannedIntervention from "./PieChartPlannedIntervention";
import {
  RightOutlined,
  LogoutOutlined,
  ClockCircleOutlined,
  PieChartOutlined
} from "@ant-design/icons";

import { allOuts as AllOutsStats } from "../../api/SurgicalInterventionsStats";
import { all as AllCareUnit } from "../../api/CareUnit.js";

import { deferredOutputReasons } from "../../constants";
import moment from "moment";
import locale from 'antd/lib/locale/fr_FR';

const { Content } = Layout;
const { Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const layoutSelect = {
  showSearch: true,
  allowClear: true,
  optionFilterProp: "children",
  filterOption: false,
  style: {
    width: "100%",
    marginTop: 8,
  }
};

const emptyLayout = {
  image: <Text type="secondary"><PieChartOutlined /></Text>,
  style: {
    margin: "100px 0",
  },
};

/**
 *
 */
class SurgicalInterventionsOutsStats extends Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);

    this.title = "Statistiques des sorties";

    this.state = {
      loading: false,
      surgicalInterventionsOutsStats: null,
      firstDay: moment().subtract(1, "weeks"),
      lastDay: moment(),
      careUnits: [],
      selectedCareUnitIds: [],
    };

    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeCareUnits = this.onChangeCareUnits.bind(this);
  }

  componentDidMount() {
    this.fetch();
    this.fetchCareUnits();
  }

  getPayload() {
    let { selectedCareUnitIds } = this.state;

    let payload = {};
    if (selectedCareUnitIds.length) {
      payload['care_unit_ids'] = selectedCareUnitIds;
    }

    return payload;
  }

  fetch() {
    this.setState({ loading: true }, () => {
      let payload = this.getPayload();
      let { firstDay, lastDay } = this.state;

      AllOutsStats(payload, firstDay, lastDay)
        .then((data) => {
          this.setState({
            surgicalInterventionsOutsStats: data.results,
            loading: false
          });
        });
    });
  }

  /**
   * 
   * @returns 
   */
  fetchCareUnits() {
    return AllCareUnit({
      current: 1,
      pageSize: 100,
      q: {},
    })
      .then((data) => {
        this.setState({ careUnits: data.results });
      });
  }

  /**
   * 
   * @param {*} dates 
   * @param {*} dateStrings 
   */
  onChangeDate(dates, dateStrings) {
    if (dates === null) {
      let firstDay = moment().subtract(1, "weeks");
      let lastDay = moment();
      dates = [firstDay, lastDay];
    }

    this.setState({
      firstDay: dates[0],
      lastDay: dates[1],
    }, () => {
      this.fetch();
    });
  }

  /**
   *
   * @param {*} value
   */
  onChangeCareUnits(value) {
    this.setState({ selectedCareUnitIds: value }, () => {
      this.fetch();
    });
  }

  render() {
    let {
      surgicalInterventionsOutsStats,
      careUnits,
      firstDay,
      lastDay,
      loading
    } = this.state;

    let careUnitOptions = careUnits.map((option, index) => (
      <Option key={index} value={option.id}>{option.name}</Option>
    ));

    let current = 0;
    let deferred = 0;
    let deferredReason = {};
    let totalDeferredWithReason = 0;

    if (!!surgicalInterventionsOutsStats) {
      current = surgicalInterventionsOutsStats['stats']['current'];
      deferred = surgicalInterventionsOutsStats['stats']['deferred'];
      deferredReason = surgicalInterventionsOutsStats['stats']['deferred_reason'];

      Object.keys(deferredReason).forEach((key) => {
        totalDeferredWithReason += deferredReason[key];
      });
    }

    const dataDeferred = deferredOutputReasons.map(reason => {
      let value = (!!surgicalInterventionsOutsStats)
        ? surgicalInterventionsOutsStats['stats']['deferred_reason'][reason.id]
        : 0;

      return { name: reason.label, value };
    });
    dataDeferred.push({
      'name': 'sans raison',
      'value': deferred - totalDeferredWithReason,
    });

    let percentDeferred = (current > 0)
      ? (deferred/current * 100).toFixed(0)
      : 0;

    return (
      <Content
        style={{
          margin: "24px 16px",
          padding: 24,
          minHeight: 280,
        }}
      >
        <Breadcrumb
          style={{ padding: 24 }}
          separator={<RightOutlined style={{ fontSize: "75%" }} />}
        >
          <Breadcrumb.Item>
            <a href="/home">Accueil</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Reporting</Breadcrumb.Item>
          <Breadcrumb.Item>{this.title}</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader ghost={false} title={this.title} subTitle="sur une période" />
        <div
          className="site-layout-background"
          style={{ padding: 24 }}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Space className="mb-4" direction="horizontal" align="end">
              <Space direction="vertical">
                <label>Dates :</label>
                <RangePicker
                  format="DD/MM/YYYY"
                  locale={locale}
                  ranges={{
                    "Aujourd'hui": [moment(), moment()],
                    "Cette semaine": [
                      moment().startOf("week"),
                      moment().endOf("week"),
                    ],
                    "Ce mois": [
                      moment().startOf("month"),
                      moment().endOf("month"),
                    ],
                    "Les 7 derniers jours": [moment().subtract(7, 'days'), moment()],
                    "Les 7 prochains jours": [moment(), moment().add(7, 'days')],
                    "Les 30 derniers jours": [moment().subtract(30, 'days'), moment()]
                  }}
                  defaultValue={[firstDay, lastDay]}
                  onChange={this.onChangeDate}
                  allowClear={false}
                />
              </Space>
            </Space>
            <Row className="mb-4" style={{ width: "100%" }}>
              <Col span={8} className="pr-3">
                <label>Unité(s) de soin(s) :</label>
                <Select
                  {...layoutSelect}
                  mode="multiple"
                  placeholder="Choisissez votre/vos unité(s)"
                  onChange={this.onChangeCareUnits}
                >
                  {careUnitOptions}
                </Select>
              </Col>
            </Row>
          </Space>
          <Row className="mt-2" gutter={16}>
            <Col span={8}>
              <Card>
                <Statistic
                  title="Sorties total durant la période"
                  value={current}
                  prefix={<LogoutOutlined />}
                  loading={loading}
                />
              </Card>
            </Col>
            <Col span={8}>
              <Card>
                <Statistic
                  title="Sorties différées"
                  value={deferred}
                  prefix={<ClockCircleOutlined />}
                  suffix={(current > 0) ? <Text>{percentDeferred}%</Text> : null}
                  loading={loading}
                />
              </Card>
            </Col>
          </Row>
          <br />
          <Row className="mb-4" gutter={16}>
            <Col span={12}>
              <PageHeader
                ghost={false}
                title={"Répartition des sorties différées"}
              />
              {(deferred > totalDeferredWithReason) ?
                <Alert
                  message="Certaines ou aucunes des sorties différées ne semblent avoir été justifiées."
                  type="info"
                />
              : null }
              {(totalDeferredWithReason > 0) ?
                <PieChartPlannedIntervention data={dataDeferred} />
              :
                <Empty {...emptyLayout} description="Aucune sortie différée" />
              }
            </Col>
          </Row>
        </div>
      </Content>
    );
  }
}

export default SurgicalInterventionsOutsStats;
